/**
 * Skus Inventory
 */

// React
import React, {
  FunctionComponent,
  useEffect,
  useState,
  useLayoutEffect,
  useRef,
  useContext,
} from 'react';
import {useHistory} from 'react-router-dom';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {getSkusInventoryActions} from '../warehouses/actions';
import {Store} from '../../redux/reducers';

// Selector
import {createStructuredSelector} from 'reselect';
import {
  makeSelectLoading,
  makeSelectError,
  makeSelectSkusInventoryList,
  makeSelectSkusInventoryListCount,
} from '../warehouses/selectors';
import {
  makeSelectInventoryItemsCount,
  makeSelectList,
  makeSelectLoading as parcelLoading,
} from '../parcels/selectors';

// Components
import Pagination from '@material-ui/lab/Pagination';
import ListSkus from './components/listSkus';
import ReportList from './components/reportList';
import ProductFilter from './components/productFilter';
import WarehouseFilter from './components/warehouseFilter';
import CartexList from './components/cartexList';
import InventoryItemsList from './components/inventoryItemsList';
import ExelExport from './exelExport';
import WarehouseInventoryMob from './mobileView/index';

// UI
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';
import {
  Typography,
  CircularProgress,
  Button,
  Grid,
  FormControl,
  Select,
  MenuItem,
  Paper,
  Box,
  IconButton,
  Card,
  CardHeader,
  CardContent,
} from '@material-ui/core';

// Helper
import {
  flattenObject,
  removeEmptyValueObject,
  checkMatchMedia,
} from '../../utils/helpers';
import skuRepository from 'client-sdk/src/Repository/skus-repository';

// Type
import {
  ProductFilters,
  Props,
  SelectorProps,
  WarehouseFilters,
} from './interfaces';

import CSV from './components/csv';
import Icon from '@mdi/react';
import {
  mdiArchiveOutline,
  mdiCounter,
  mdiKeyOutline,
  mdiPlusBoxOutline,
  mdiPrinter,
  mdiVectorPolylineEdit,
} from '@mdi/js';
import Modal from '../../components/Modal';
import {
  getParcelInventoryItemsAction,
  getParcelsAction,
} from '../parcels/actions';
import {
  makeSelectInventoryItemsList,
  makeSelectInventoryItemsLoading,
} from '../parcels/selectors';
import {GetCardIndexRequestBuilder} from 'client-sdk/src/parcels/parcels';
import Client from 'client-sdk/src/client';
import {InventoryItems} from '../parcelsSender/interfaces';
import handleError from '../../utils/handleError';
import {
  GetInventoryFlowRequestBuilder,
  GetSkusInventoryRequestBuilder,
} from 'client-sdk/src/skus/skus';
import Can from '../../components/Can';
import AuthContext from '../../authContext';
import {SkuInventory} from '../warehouses/interfaces';
import CardIndexCsv from './components/cardIndexCsv';
import InventorySetting from './components/InventorySetting';
import useQuery from '../../utils/hook/useQuery';
import {GetAllOrdersRequestBuilder} from 'client-sdk/src/orders/orders';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import windowSize from '../../utils/hook/useWindowResize';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    paper: {
      position: 'relative',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '30vh',
      minWidth: '50vw',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    box: {
      display: 'flex',
      backgroundColor: '#fff',
      padding: theme.spacing(2, 3),
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    boxIcon: {
      // display: 'flex',
      // alignItems: 'center',
      marginRight: '30px',
    },
    allCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#B297A7',
      },
    },
    activeCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#039590',
      },
    },

    title: {
      display: 'flex',
      alignItems: 'center',
      color: '#8A8A8A',
      fontSize: '16px',
      fontWeight: 500,
      marginRight: '8px',
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '21px',
      fontWeight: 500,
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      padding: '10px 0',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },

    input: {
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      marginRight: '10px',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      top: '47px',
      right: '0',
      marginTop: '30px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
    },
    titleBar: {
      padding: '5px 2px',
      width: '100%',
      borderRadius: '0',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },

    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    btnBox: {
      marginTop: '8px',
      display: 'flex',
      flexDirection: 'row-reverse',
      width: '100%',
      '@media (max-width: 480px)': {
        display: 'none',
        justifyContent: 'space-between',
        width: '100%',
      },
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },

    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    card: {
      minWidth: '195px',
      display: 'flex',
      background: '#fff',
      padding: '8px 4px',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    cardItem: {
      margin: '0 4px',
      flex: 1,
    },
    typographyCards: {
      fontSize: '16px',
      color: 'white',
      backgroundColor: '#4BCF90',
      padding: '8px 24px 8px 50px',
      marginLeft: '-40px',
    },
    cards: {
      width: '100%',
      marginBottom: '14px',
      overflow: 'visible',
      padding: '14px 0 0',
      paddingBottom: '0',
    },

    cardContentOrder: {
      padding: '0',
    },
    cardContent: {
      marginTop: '-22px',
      display: 'flex',
    },
    cardContentlist: {
      justifyContent: 'space-between',
      padding: ' 0',
    },
  })
);

enum Type {
  skus = 'skus',
  warehouse = 'warehouse',
}

const WarehouseInventory: FunctionComponent<Props> = (props: Props) => {
  const authContext = useContext(AuthContext);
  const classes = useStyles();
  const token = localStorage.getItem('token') || '';
  const {filtersValues, setFiltersValues} = useQuery({
    page: 0,
    size: 10,
  } as any);
  const [cartex, setCartex] = useState(false as boolean);
  const [type, setType] = useState(Type.skus);
  const [numSelected, setNumSelected] = useState(0);
  const [variants, setVariants] = useState([]);
  const [variantsLoading, setVariantsLoading] = useState(false as boolean);
  const [variantsError, setVariantsError] = useState({});
  const [ids, setIds] = useState([] as any);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [selectedItems, setSelectedItems] = useState<any>([]);
  const [loadingCartex, setLoadingCartex] = useState(false as boolean);
  const [cartexData, setCartexData] = useState<null | InventoryItems[]>(null);
  const [reportModal, setReportModal] = useState(false as boolean);
  const [parcelItemsModal, setParcelItemsModal] = useState(false as boolean);
  const [inventoryFilters, setInventoryFilters] = useState({
    page: 0,
    size: 10,
  } as any);
  const [openSizeInventory, setOpenSizeInventory] = React.useState(
    false as boolean
  );
  const [openSizeReport, setOpenSizeReport] = React.useState(false as boolean);
  const [openInventorySettingModal, setOpenInventorySettingModal] =
    React.useState(false as boolean);
  const [inventoryVariantId, setInventoryVariantId] = React.useState(
    -1 as number
  );
  const [reportLoading, setReportLoading] = useState(false as boolean);
  const [reportList, setReportList] = useState<any>(null);
  const [reportFilters, setReportFilters] = useState<any>({
    page: 0,
    size: 10,
  });
  const [reportId, setReportId] = useState(null as any);
  const [csvData, setCsvData] = useState<SkuInventory[]>([]);
  const [csvDataLoading, setCsvDataLoading] = useState(false);
  const [cardIndexCsvLoading, setCardIndexCsvLoading] = useState(
    false as boolean
  );
  const [cardIndexCsvData, setCardIndexCsvData] = useState([]);
  const [reportCsvData, setReportCsvData] = useState([]);
  const [reportCsvLoading, setReportCsvLoading] = useState(false);
  const [isMob, setIsMob] = useState(false);
  const {width} = windowSize();

  const history = useHistory();

  const getAllVariantsCsv = async (actions: any) => {
    const payload = {...actions, pagination: {page: 0, size: 10000}};
    try {
      setVariantsLoading(true);
      const response = await skuRepository.getSkusInventory({
        payload,
      });
      setVariants(response.data.content);
    } catch (error) {
      setVariantsError(error);
    } finally {
      setVariantsLoading(false);
    }
  };

  useEffect(() => {
    getSkusInventory();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    return () => {
      setCsvData([]);
    };
  }, [type]);

  useEffect(() => {
    if (ids.length) {
      const selectedItemsDetail = props.skusInventoryList.filter(
        (sku: SkuInventory) => ids.includes(sku.id)
      );
      setSelectedItems(selectedItemsDetail);
    }
  }, [ids]);

  useEffect(() => {
    if (width && width <= 480) {
      setIsMob(true);
    } else {
      setIsMob(false);
    }
  }, [width]);

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({...filtersValues, page: page - 1});
  };

  const handleChangeInventoryPage = (
    _: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setInventoryFilters({...inventoryFilters, page: page - 1});
    getParcelInventoryRequest({...inventoryFilters, page: page - 1});
  };

  const handleChangeReportPage = (
    _: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setReportFilters({...reportFilters, page: page - 1});
    fetchReportList(reportId, {...reportFilters, page: page - 1});
  };

  const getSkusInventory = () => {
    props.getSkusInventory({
      pagination: {...removeEmptyValueObject(filtersValues)},
    });
  };

  const handleSearchWarehouse = (values: WarehouseFilters) => {
    setFiltersValues((prevState: {[key: string]: any}) => ({
      ...prevState,
      ...values,
      page: 0,
      size: 10,
    }));
  };

  const handleSearchProduct = (values: ProductFilters) => {
    setFiltersValues({
      ...values,
      page: 0,
      size: 10,
    });
  };

  const handleClose = () => {
    setOpenSize(false);
  };

  const handleOpenInventorySetting = () => {
    setOpenInventorySettingModal(true);
  };

  const handleCloseInventory = () => {
    setOpenSizeInventory(false);
  };

  const handleOpenCartexModal = (id: number) => {
    findSelectedItem(id);
    getCardIndex(id);
    setCartex(true);
  };

  const handleOpenInventorySettingModal = (id: number) => {
    findSelectedItem(id);
    setInventoryVariantId(id);
    setIds([id]);
    setOpenInventorySettingModal(true);
  };

  const handleChangeInventorySetting = () => {
    handleCloseInventorySettingModal();
  };

  const findSelectedItem = (id: number) => {
    const findSelectSku = props.skusInventoryList.find(
      (el: any) => el.id === id
    )!;
    setSelectedItem(findSelectSku);
  };

  const getCardIndex = async (id: number) => {
    try {
      // const flat = flattenObject(filtersValues);
      setLoadingCartex(true);
      const request = new GetCardIndexRequestBuilder()
        .params({
          // ...removeEmptyValueObject(flat),
          // page: undefined,
          'skuId.equals': id,
          'status.equals': 'LOCATED',
          size: 100,
        })
        .build();
      const client = new Client(token);
      const {data} = await client.execute(request);
      setCartexData(data);
    } catch (e) {
      handleError(e.response);
    } finally {
      setLoadingCartex(false);
    }
  };

  const handleCloseCartexModal = () => {
    setCartex(false);
    setSelectedItem(null);
    setCardIndexCsvData([]);
  };

  const handleCloseInventorySettingModal = () => {
    setOpenInventorySettingModal(false);
    setSelectedItem(null);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{value: unknown}>) => {
    setFiltersValues({...filtersValues, page: 0, size: event.target.value});
  };

  const handleChangeSizePageInventory = (
    event: React.ChangeEvent<{value: unknown}>
  ) => {
    setInventoryFilters({
      ...inventoryFilters,
      page: 0,
      size: event.target.value,
    });
    getParcelInventoryRequest({...inventoryFilters, size: event.target.value});
  };

  const handleChangeSizeReportList = (
    event: React.ChangeEvent<{value: unknown}>
  ) => {
    setReportFilters({...reportFilters, page: 0, size: event.target.value});
    fetchReportList(reportId, {...reportFilters, size: event.target.value});
  };

  const handleChangeType = (types: Type) => {
    if (types !== type) {
      setType(types);
      clearFilters();
      setFiltersValues({
        page: 0,
        size: 10,
      });
    }
  };

  const clearFilters = () => {
    setFiltersValues({
      size: 10,
      page: 0,
    });
  };

  const handleReport = (id: number) => {
    setReportModal(true);
    setReportId(id);
    fetchReportList(id);
    // props.getParcelsDispatch({'skuId.equals': id, size: 150});
    findSelectedItem(id);
  };

  const fetchReportList = async (id: number, args: Record<string, any>) => {
    try {
      setReportLoading(true);
      const request = new GetInventoryFlowRequestBuilder()
        .id(id)
        .params({
          ...removeEmptyValueObject(flattenObject(reportFilters)),
          ...args,
        })
        .build();
      const client = new Client(token);
      const {data} = await client.execute(request);
      setReportList(data);
    } catch (err) {
      handleError(err.response);
    } finally {
      setReportLoading(false);
    }
  };

  const handleCloseReportModal = () => {
    setReportModal(false);
    setReportList(null);
    setReportCsvData([]);
  };

  const handleGetParcelInventory = (id: number) => {
    setParcelItemsModal(true);
    setInventoryFilters((prevState: Record<string, any>) => ({
      ...prevState,
      'parcelId.equals': id,
    }));
    getParcelInventoryRequest({'parcelId.equals': id});
  };

  const getParcelInventoryRequest = (arg: Record<string, any>) => {
    props.getParcelInventoryItems({...inventoryFilters, ...arg});
  };

  const handleCloseParcelInventoryModal = () => {
    setParcelItemsModal(false);
    setInventoryFilters({
      page: 0,
      size: 10,
    });
  };

  const fetchCsvData = async () => {
    try {
      setCsvDataLoading(true);
      const makeRequest = new GetSkusInventoryRequestBuilder()
        .params(flattenObject({...filtersValues, size: 1000, page: undefined}))
        .build();
      const client = new Client(token);
      const {data} = await client.execute(makeRequest);
      setCsvData(data.content);
    } catch (e) {
      handleError(e.response);
    } finally {
      setCsvDataLoading(false);
    }
  };

  const fetchCardIndexCsv = async () => {
    try {
      setCardIndexCsvLoading(true);
      // @ts-ignore
      const variantId = cartexData[0].variantId!;
      const makeRequest = new GetCardIndexRequestBuilder()
        .params({
          size: 1000,
          'skuId.equals': variantId,
          'status.equals': 'LOCATED',
        })
        .build();
      const client = new Client(token);
      const {data} = await client.execute(makeRequest);
      setCardIndexCsvData(data);
    } catch (err) {
      handleError(err.response);
    } finally {
      setCardIndexCsvLoading(false);
    }
  };

  const fetchReportCsv = async () => {
    try {
      setReportCsvLoading(true);
      const parcelId = selectedItem.id;
      const request = new GetInventoryFlowRequestBuilder()
        .id(parcelId)
        .params({size: 10000})
        .build();
      const client = new Client(token);
      const {data} = await client.execute(request);
      setReportCsvData(data.content);
    } catch (e) {
      handleError(e.response);
    } finally {
      setReportCsvLoading(false);
    }
  };

  return isMob ? (
    <WarehouseInventoryMob {...props} />
  ) : (
    <div className={classes.root}>
      <Grid
        style={{
          zIndex: 3,
          backgroundColor: 'white',
          position: 'fixed',
          top: '0',
          right: '71px',
        }}
        container
      >
        <Paper elevation={1} className={classes.titleBar}>
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              لیست موجودی انبار
            </Typography>
          </div>
          <div
            style={{
              marginLeft: '140px',
            }}
          ></div>
        </Paper>
      </Grid>
      <Grid container spacing={1} style={{marginTop: '20px'}}>
        <Card className={classes.cards}>
          <CardHeader
            avatar={
              <Typography className={classes.typographyCards}>
                جستجو کالا
              </Typography>
            }
          />
          <CardContent style={{paddingBottom: '0'}}>
            {type === 'skus' ? (
              <ProductFilter
                clearForm={clearFilters}
                submitFilters={handleSearchProduct}
              />
            ) : (
              <WarehouseFilter
                clearForm={clearFilters}
                submitFilters={handleSearchWarehouse}
              />
            )}
          </CardContent>
        </Card>
      </Grid>

      <Grid container spacing={1} style={{marginTop: '20px'}}>
        <Card className={classes.cards}>
          <CardHeader
            avatar={
              <Grid>
                <Typography className={classes.typographyCards}>
                  لیست کالاهای موجودی انبار
                </Typography>
              </Grid>
            }
            action={
              <div className={classes.btnBox}>
                {/* <CSV
                  handleCreateCSV={getAllVariantsCsv}
                  data={variants}
                  filtersValues={{
                    page: 0,
                    size: 10000,
                  }}
                  loading={variantsLoading}
                /> */}
                <ExelExport
                  data={variants}
                  loading={variantsLoading}
                  filtersValues={{
                    page: 0,
                    size: 10000,
                  }}
                  handleRequest={getAllVariantsCsv}
                />
                <Button
                  variant="contained"
                  color="primary"
                  style={{marginLeft: '8px'}}
                  onClick={() => history.push('/create-grouping-inventory')}
                  size={
                    checkMatchMedia('(max-width: 1024px)') ? 'small' : 'large'
                  }
                  startIcon={<Icon path={mdiPlusBoxOutline} size={1} />}
                >
                  {`بارگذاری گروهی تنظیمات موجودی`}
                </Button>
                {numSelected >= 1 && (
                  <React.Fragment>
                    <Button
                      style={{marginLeft: '5px'}}
                      variant="contained"
                      color="secondary"
                      onClick={() => handleOpenInventorySetting()}
                    >
                      تنظیمات گروهی موجودی کالا
                    </Button>
                  </React.Fragment>
                )}
              </div>
            }
          />
          <CardContent className={classes.cardContentOrder}>
            <Grid container lg={12} md={12} className={classes.cardContentlist}>
              <Grid container item lg={12} md={12}>
                <Grid container item xs={12} md={12} lg={12}>
                  {props.loading ? (
                    <div className={classes.loading}>
                      <CircularProgress />
                    </div>
                  ) : (
                    <React.Fragment>
                      <Grid
                        container
                        item
                        xs={12}
                        justify="flex-end"
                        direction="row-reverse"
                        alignItems="center"
                        style={{marginBottom: '20px'}}
                      >
                        <div className={classes.btnBox}>
                          <></>
                        </div>
                      </Grid>
                      <ListSkus
                        type={type}
                        openCartexModal={handleOpenCartexModal}
                        openInventorySettingModal={
                          handleOpenInventorySettingModal
                        }
                        handleNumSelect={(ids: [], num: number) => {
                          setNumSelected(num);
                          setIds(ids);
                        }}
                        handleReport={handleReport}
                        data={props.skusInventoryList}
                      />
                    </React.Fragment>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} style={{padding: '20px 10px 0 10px'}}>
                  <FormControl
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{marginLeft: '10px', color: '#8a8a8a'}}>
                      {' '}
                      تعداد نمایش در هر صفحه:
                    </div>
                    <Select
                      open={openSize}
                      onClose={handleClose}
                      onOpen={() => setOpenSize(true)}
                      value={filtersValues.size}
                      onChange={handleChangeSizePage}
                    >
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={20}>20</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                      <MenuItem value={100}>100</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid
                  xs={12}
                  sm={6}
                  container
                  item
                  direction="row-reverse"
                  style={{padding: '20px 10px 0 10px'}}
                >
                  <Pagination
                    className={classes.pagination}
                    count={Math.ceil(
                      props.skusInventoryListCount / filtersValues.size
                    )}
                    color="secondary"
                    page={filtersValues.page + 1}
                    onChange={handleChangePage}
                  />
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Modal
        maxWidth="md"
        onClose={handleCloseCartexModal}
        open={cartex}
        title={
          <div style={{textAlign: 'right'}}>
            <span>{`کارتکس کالای ${selectedItem?.partnerName}`}</span>
          </div>
        }
        content={
          <React.Fragment>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {/* <Icon
                      path={mdiArchiveOutline}
                      size={1}
                      className={classes.icon}
                    /> */}
                    {`نام کالا:  `}
                  </span>

                  <span>{selectedItem?.productName}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {/* <Icon
                      path={mdiKeyOutline}
                      size={1}
                      className={classes.icon}
                    /> */}
                    {`شناسه کلا:  `}
                  </span>
                  <span>{selectedItem?.productId}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {/* <Icon path={mdiCounter} size={1} className={classes.icon} /> */}
                    {`کد کالا:  `}
                  </span>
                  <span>{selectedItem?.productCode}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {/* <Icon
                      path={mdiKeyOutline}
                      size={1}
                      className={classes.icon}
                    /> */}
                    {`شناسه تنوع:  `}
                  </span>
                  <span>{selectedItem?.id}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {/* <Icon
                      path={mdiVectorPolylineEdit}
                      size={1}
                      className={classes.icon}
                    /> */}
                    {`فروشنده/تامین‌کننده:  `}
                  </span>
                  <span>
                    {selectedItem?.providerName
                      ? selectedItem?.providerName
                      : selectedItem?.sellerName}
                  </span>
                </div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {/* <Icon
                      path={mdiVectorPolylineEdit}
                      size={1}
                      className={classes.icon}
                    /> */}
                    {`کد فروشنده/تامین‌کننده:  `}
                  </span>
                  <span>
                    {selectedItem?.providerId
                      ? selectedItem?.providerId
                      : selectedItem?.sellerId}
                  </span>
                </div>
              </Grid>

              <Grid item xs={12}>
                {loadingCartex ? (
                  <div className={classes.loading}>
                    <CircularProgress />
                  </div>
                ) : (
                  <React.Fragment>
                    <Grid item xs={12}>
                      <div style={{textAlign: 'left'}}>
                        <Can
                          role={authContext.user.role}
                          perform="skus:downloadCSV"
                          yes={() => (
                            <>
                              {cartexData?.length > 0 && (
                                <CardIndexCsv
                                  loading={cardIndexCsvLoading}
                                  handleCreateCSV={fetchCardIndexCsv}
                                  data={cardIndexCsvData}
                                />
                              )}
                            </>
                          )}
                        />
                      </div>
                      <Box mb={3} />
                    </Grid>
                    <CartexList data={cartexData} />
                  </React.Fragment>
                )}
              </Grid>
            </Grid>
          </React.Fragment>
        }
      />

      <Modal
        maxWidth="md"
        onClose={handleCloseInventorySettingModal}
        open={openInventorySettingModal}
        title={
          <div style={{textAlign: 'center'}}>
            <span>{`تنظیمات موجودی کالا `}</span>
          </div>
        }
        content={
          <InventorySetting
            id={inventoryVariantId}
            selectedItems={numSelected}
            selectedItemsDetail={selectedItems}
            handleChangeInventorySetting={handleChangeInventorySetting}
          />
        }
      />

      <Modal
        maxWidth="md"
        onClose={handleCloseReportModal}
        open={reportModal}
        title={
          <div style={{textAlign: 'center'}}>
            <span>{`تاریخچه ورود و خروج کالای ${selectedItem?.productName}`}</span>
          </div>
        }
        content={
          <Grid container spacing={3}>
            <Grid item xs={12}>
              {reportLoading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                <React.Fragment>
                  <Grid item xs={12}>
                    <div style={{textAlign: 'left'}}>
                      <Can
                        role={authContext.user.role}
                        perform="skus:downloadCSV"
                        yes={() => (
                          <CSV
                            loading={reportCsvLoading}
                            handleCreateCSV={fetchReportCsv}
                            data={reportCsvData}
                          />
                        )}
                      />
                    </div>
                    <Box mb={3} />
                  </Grid>
                  <ReportList
                    data={reportList?.content}
                    handleSelect={handleGetParcelInventory}
                  />
                </React.Fragment>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <div style={{marginLeft: '10px', color: '#8a8a8a'}}>
                  {' '}
                  تعداد نمایش در هر صفحه:
                </div>
                <Select
                  open={openSizeReport}
                  onClose={() => setOpenSizeReport(false)}
                  onOpen={() => setOpenSizeReport(true)}
                  value={reportFilters.size}
                  onChange={handleChangeSizeReportList}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={12} sm={6} container item direction="row-reverse">
              <Pagination
                className={classes.pagination}
                count={Math.ceil(
                  reportList?.totalElements / reportFilters.size
                )}
                color="secondary"
                page={reportFilters?.page + 1}
                onChange={handleChangeReportPage}
              />
            </Grid>
          </Grid>
        }
      />

      <Modal
        fullScreen
        onClose={handleCloseParcelInventoryModal}
        open={parcelItemsModal}
        title={
          <div style={{textAlign: 'right'}}>
            <span>{`آیتم های محموله شماره ${props.inventoryItemsList?.[0]?.parcelId}`}</span>
          </div>
        }
        content={
          <Grid container spacing={3}>
            <Grid item xs={12}>
              {props.inventoryItemsListLoading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                <InventoryItemsList data={props.inventoryItemsList} />
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <div style={{marginLeft: '10px', color: '#8a8a8a'}}>
                  {' '}
                  تعداد نمایش در هر صفحه:
                </div>
                <Select
                  open={openSizeInventory}
                  onClose={handleCloseInventory}
                  onOpen={() => setOpenSizeInventory(true)}
                  value={inventoryFilters.size}
                  onChange={handleChangeSizePageInventory}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={12} sm={6} container item direction="row-reverse">
              <Pagination
                className={classes.pagination}
                count={Math.ceil(
                  props.inventoryItemsListCount / inventoryFilters.size
                )}
                color="secondary"
                page={inventoryFilters.page + 1}
                onChange={handleChangeInventoryPage}
              />
            </Grid>
          </Grid>
        }
      />
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  skusInventoryListCount: makeSelectSkusInventoryListCount(),
  skusInventoryList: makeSelectSkusInventoryList(),
  loading: makeSelectLoading(),
  parcelsList: makeSelectList(),
  parcelLoading: parcelLoading(),
  inventoryItemsList: makeSelectInventoryItemsList(),
  inventoryItemsListCount: makeSelectInventoryItemsCount(),
  inventoryItemsListLoading: makeSelectInventoryItemsLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getSkusInventory: (payload: {pagination: object}) =>
      dispatch(getSkusInventoryActions(payload)),
    getParcelInventoryItems: (payload: any) =>
      dispatch(getParcelInventoryItemsAction(payload)),
    getParcelsDispatch: (payload: any) => dispatch(getParcelsAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
// @ts-ignore
export default compose(withConnect)(WarehouseInventory);
